import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const SizeBestFitIcon = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19"
  }, props),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "best-fit-path",
      d: "M17 3.2v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h14.6c.11 0 .2.09.2.2zm0 12v.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2h14.6c.11 0 .2.09.2.2zM2.2 6h14.6c.11 0 .2.09.2.2v6.6a.2.2 0 0 1-.2.2H2.2a.2.2 0 0 1-.2-.2V6.2c0-.11.09-.2.2-.2zM3 7v5h13V7H3z"
    }
  )),
  /* @__PURE__ */ React.createElement("g", { fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("mask", { id: "best-fit-mask" }, /* @__PURE__ */ React.createElement("use", { xlinkHref: "#best-fit-path" })), /* @__PURE__ */ React.createElement("use", { fillRule: "nonzero", xlinkHref: "#best-fit-path" }))
);

export { SizeBestFitIcon as default };
//# sourceMappingURL=SizeBestFitIcon.js.map
